// Abonelik, kullanım ve firma ayarları (C80–C87): Control yönlendirmeleri (izin + bayrak korumalı, tembel yüklenir).
import { Navigate, Route } from 'react-router';
import { guard, load } from '../route-utils';

const Plan = load(() => import('./subscription/Plan'), 'Plan');
const Usage = load(() => import('./subscription/Usage'), 'Usage');
const Upgrade = load(() => import('./subscription/Upgrade'), 'Upgrade');
const CompanyProfile = load(() => import('./settings/CompanyProfile'), 'CompanyProfile');
const Branding = load(() => import('./settings/Branding'), 'Branding');
const NotificationSettings = load(() => import('./settings/NotificationSettings'), 'NotificationSettings');
const TripRules = load(() => import('./settings/TripRules'), 'TripRules');
const Privacy = load(() => import('./settings/Privacy'), 'Privacy');

export const accountRoutes = (
  <>
    <Route path="abonelik" element={guard(Plan, 'billing')} />
    <Route path="abonelik/kullanim" element={guard(Usage, 'billing')} />
    <Route path="abonelik/yukselt" element={guard(Upgrade, 'billing')} />
    <Route path="ayarlar" element={<Navigate to="/operasyon/ayarlar/firma" replace />} />
    <Route path="ayarlar/firma" element={guard(CompanyProfile, 'settings')} />
    <Route path="ayarlar/marka" element={guard(Branding, 'settings', { flag: 'WHITE_LABEL' })} />
    <Route path="ayarlar/bildirimler" element={guard(NotificationSettings, 'settings')} />
    <Route path="ayarlar/sefer-kurallari" element={guard(TripRules, 'settings')} />
    <Route path="ayarlar/gizlilik" element={guard(Privacy, 'settings')} />
  </>
);
